var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.704 10.896a1.7 1.7 0 0 1 1.7 1.7v17.85a1.7 1.7 0 1 1-3.4 0V16.698L13.602 37.102a1.7 1.7 0 0 1-2.244.142l-.16-.142a1.7 1.7 0 0 1 0-2.404l20.4-20.402H17.854a1.7 1.7 0 0 1-1.688-1.502l-.012-.198a1.7 1.7 0 0 1 1.7-1.7z"
  })));
};
export default SvgLink;